var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAlertCam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_alert_cam"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66732 3.33333H13.334V8.80469C13.8289 8.94467 14.2813 9.18598 14.6673 9.50478V2.662C14.6673 2.29667 14.3713 2 14.006 2H1.99532C1.82024 2.0014 1.65273 2.07161 1.52899 2.19548C1.40525 2.31934 1.3352 2.48692 1.33398 2.662V13.338C1.33398 13.5135 1.40364 13.6817 1.52764 13.8059C1.65165 13.93 1.81986 13.9998 1.99532 14H9.06712C8.8115 13.5 8.66732 12.9335 8.66732 12.3333C8.66732 10.4173 10.137 8.84448 12.0106 8.68074L9.80465 6.47067C9.67963 6.34569 9.51009 6.27548 9.33332 6.27548C9.15654 6.27548 8.987 6.34569 8.86198 6.47067L2.66732 12.6667V3.33333ZM4.39118 6.94281C4.64122 7.19286 4.98036 7.33333 5.33398 7.33333C5.68761 7.33333 6.02674 7.19286 6.27679 6.94281C6.52684 6.69276 6.66732 6.35362 6.66732 6C6.66732 5.64638 6.52684 5.30724 6.27679 5.05719C6.02674 4.80714 5.68761 4.66667 5.33398 4.66667C4.98036 4.66667 4.64122 4.80714 4.39118 5.05719C4.14113 5.30724 4.00065 5.64638 4.00065 6C4.00065 6.35362 4.14113 6.69276 4.39118 6.94281Z",
    fill: "current"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.167 14.5H11.667V16H13.167V14.5Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.167 10H11.667V13.75H13.167V10Z",
    fill: "current"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertCam);
export default __webpack_public_path__ + "static/media/ic_alert_cam.07f37d52701695b5f417a8608779cb54.svg";
export { ForwardRef as ReactComponent };